
















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";

@Component
export default class ListImplementasiMpp extends Vue {
  @Prop({ default: () => [] }) items!: any[];
  @Prop({ default: "300px" }) height!: string;
  @Prop({ type: Boolean, default: false }) isReadonly!: boolean;

  get headers() {
    const allHeaders = [
      { text: "No", value: "no", sortable: false, width: "3%" },
      {
        text: "Tanggal / Ruang / Petugas",
        value: "info_gabungan",
        sortable: false,
        width: "15%"
      },
      {
        text: "Implementasi",
        value: "implementasi",
        sortable: false,
        width: "35%"
      },
      { text: "Evaluasi", value: "evaluasi", sortable: false, width: "30%" },
      {
        text: "Keterangan",
        value: "keterangan",
        sortable: false,
        width: "15%"
      },
      {
        text: "Aksi",
        value: "aksi",
        sortable: false,
        width: "2%",
        align: "center"
      }
    ];

    if (this.isReadonly) {
      return allHeaders.filter(h => h.value !== "aksi");
    }

    return allHeaders;
  }

  formatTanggal(authored_at: string) {
    if (!authored_at) return "-";
    return moment(authored_at).format("DD-MM-YYYY HH:mm");
  }

  // Mengurutkan item berdasarkan authored_at terbaru di atas
  get sortedItems() {
    return [...this.items].sort((a, b) => {
      return (
        new Date(b.authored_at).getTime() - new Date(a.authored_at).getTime()
      );
    });
  }

  getSortedData(data) {
    if (!data) return [];
    return data.slice().sort((a, b) => {
      // Contoh: ID 99 selalu terakhir, sisanya urut angka
      if (a.id == 99) return 1;
      if (b.id == 99) return -1;
      return a.id - b.id;
    });
  }

  get stateUser() {
    return userModule.user;
  }

  isRowReadonly(item: any): boolean {
    if (this.isReadonly) return true;

    if (!this.stateUser) return true;

    const isOwner = Number(item.user_id) === Number(this.stateUser.id);
    const isSameUnit = String(item.unit_id) === String(this.stateUser.unit_id);

    return !(isOwner && isSameUnit);
  }
}
